import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const fromTimeOffCategoryFormToData = (form) => ({
  categoryId: form?.category?.id || form?.event?.time_off_category?.id || form?.event?.time_off_category_id,
  note: fromAnyToTrimmed(form?.note) || fromAnyToTrimmed(form?.event?.notes),
});

export default fromTimeOffCategoryFormToData;
